import React from 'react';
import { COLORS } from '../config';

const LoginHeaderWrapper = ({ children, style, ...props }) => {
  return (
    <div
      style={{
        padding: 16,
        paddingBottom: 64,
        backgroundImage: `url('/images/new-login.jpg')`,
       backgroundColor: "rgba(0, 129, 147, 0.3)",
        backgroundBlendMode: 'darken',
        backgroundSize: 'cover',
        borderRadius: '0 0 300px 300px', //FIXME : border depending on screen or div width ??
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 0,
        ...style,
      }}
    >
      <img
        src='/images/logoFull.png'
        alt='Logo DBI'
        width={200}
        style={{ marginTop: 48 }}
      />
      {children}
    </div>
  );
};

export { LoginHeaderWrapper };
